// BL-392 shared auth-email markup (Edge Functions + tests). Inline styles and tables only, so the
// header and pill CTA survive Gmail, Outlook, and Apple Mail.
export const AUTH_PILL_BLUE = '#155eef';

export function escapeEmailHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

export function safeEmailLogoUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
        const url = new URL(value.trim());
        return url.protocol === 'https:' && !url.username && !url.password ? url.toString() : null;
    } catch {
        return null;
    }
}

// "assignable_admin" -> "Assignable Admin"
export function titleCaseRole(value, fallback = 'Team Member') {
    const words = String(value ?? '').replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
    return words ? words.replace(/\b[a-z]/g, (c) => c.toUpperCase()) : fallback;
}

// Centered Company logo (max 160px wide). The caller passes Company logo -> Organization logo;
// with neither (or an unusable URL) the Company name is the wordmark. alt is the Company name,
// so even a logo the mail client blocks reads as the name instead of a broken icon.
export function authEmailHeader(company, logo) {
    const name = escapeEmailHtml(company);
    const url = safeEmailLogoUrl(logo);
    const mark = url
        ? `<img src="${escapeEmailHtml(url)}" alt="${name}" style="display:block;margin:0 auto;max-width:160px;max-height:80px;width:auto;height:auto;border:0;outline:none;text-decoration:none;font-size:22px;font-weight:700;color:#1f2937">`
        : `<div style="font-size:24px;line-height:32px;font-weight:700;color:#1f2937;text-align:center">${name}</div>`;
    return `<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="padding:0 0 24px 0">${mark}</td></tr></table>`;
}

// Hollow outlined oval: transparent fill, 1px blue border + text.
export function authEmailPill(href, label) {
    const safeHref = escapeEmailHtml(href);
    const safeLabel = escapeEmailHtml(label);
    return `<table role="presentation" cellpadding="0" cellspacing="0" border="0" align="center" style="margin:24px auto"><tr>`
        + `<td align="center" style="border:1px solid ${AUTH_PILL_BLUE};border-radius:999px;mso-padding-alt:12px 28px">`
        + `<a href="${safeHref}" target="_blank" style="display:inline-block;padding:12px 28px;border-radius:999px;background-color:transparent;color:${AUTH_PILL_BLUE};font-family:Arial,sans-serif;font-size:16px;font-weight:600;line-height:20px;text-decoration:none">${safeLabel}</a>`
        + `</td></tr></table>`
        + `<p style="font-size:12px;color:#667085;text-align:center">Button not working? Paste this link into your browser:<br><a href="${safeHref}" style="color:${AUTH_PILL_BLUE};word-break:break-all">${safeHref}</a></p>`;
}

export const AUTH_EMAIL_POWERED_BY = 'Powered by smarTEKnowledgy';

export function authEmailFooter(company, whiteLabelEmails = false, poweredBy = false) {
    if (poweredBy) return AUTH_EMAIL_POWERED_BY;
    return `Sent by ${company}${whiteLabelEmails === true ? '' : ' via IntelAgent'}`;
}

export function authEmailFrame(company, logo, content, whiteLabelEmails = false, poweredBy = false) {
    return `<div style="font-family:Arial,sans-serif;color:#1f2937;line-height:1.55;max-width:600px;margin:0 auto">`
        + `${authEmailHeader(company, logo)}${content}`
        + `<p style="margin-top:32px;color:#667085;font-size:12px">${escapeEmailHtml(authEmailFooter(company, whiteLabelEmails, poweredBy))}</p></div>`;
}
export const INVITE_PASSWORD_NOTICE = 'This sets your password for all IntelAgent apps (Central Command and Driver App). It replaces any password you used before.';
